//import Vue from 'vue'
import crypto from '@/util/crypto'
import util from '@/util/public'

/* 特殊加密函式 */
/** 儲存個人資訊 */
export function saveCryptoUserInfo(userInfo) {
    if (util.notNull(userInfo) && userInfo !== '') {
        localStorage.setItem('userInfo', crypto.encryptObject(userInfo));
        return true;
    } else {
        localStorage.setItem('userInfo', '');
    }
    return false;
}

/** 取得user電話 */
export function getCryptoUserPhone() {
    let value = localStorage.getItem('phone') || "" ;
    let userPhone = crypto.decryptText(value);
    return userPhone;
}

/** 儲存user電話 */
export function saveCryptoUserPhone(userPhone) {
    if (util.notNull(userPhone) && userPhone !== '') {
        localStorage.setItem('phone', crypto.encryptText(userPhone));
        return true;
    } else {
        localStorage.setItem('phone', '');
    }
    return false;
}

/** 取得個人資訊 */
export function getCryptoUserInfo() {
    let value = localStorage.getItem('userInfo') || "" ;
    let userInfo = crypto.decryptObjectText(value);
    return userInfo;
}

/** 檢查 & 替換個人資訊 */
export function replaceUserInfo() {
    let value = localStorage.getItem('userInfo') || "" ;

    try {
        JSON.parse(value);
    } catch (e) {
        //錯誤，可能已有加密
        return false; // error in the above string (in this case, yes)!
    }
    //轉譯成功，重新加密儲存個人資訊
    localStorage.setItem('userInfo', crypto.encryptText(value));

    return true;
}

/** 檢查 & 替換個人資訊 */
export function replaceUserPhone() {
    let value = localStorage.getItem('phone') || "" ;
    let regexp = /^09\d{8}$/;
    if (regexp.test(value)) {
        //是未加密的電話號碼
        localStorage.setItem('phone', crypto.encryptText(value));
    }
    return true;
}